import { ERROR_MESSAGE_FIELD } from '@/utils/constants/messages';
import { UploadFile } from 'antd/lib';
import * as yup from 'yup';

const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
const FILE_SIZE_LIMIT = 10 * 1024 * 1024;

export const formSchemaFn = (isActionEdit: boolean) =>
  yup.object().shape({
    companyName: yup
      .string()
      .trim()
      .required('企業名は未入力です。')
      .max(100, '企業名は100文字以内で入力してください。'),
    description: yup
      .string()
      .required('説明文章は未入力です。')
      .max(1000, '説明文章は1000文字以内で入力してください。'),
    coverImage: yup.mixed().test('coverImageValidation', '', function (value) {
      const attachments = this.parent.attachments;

      // If no attachments uploaded, coverImage is required
      if (!attachments || !attachments?.fileList?.length) {
        if (!value) {
          return this.createError({
            message: 'カバー画像をアップロードしてください。',
          });
        }
        return true;
      }

      return true;
    }),
    profileImage: yup
      .mixed()
      .test('profileImageValidation', '', function (value) {
        const profileAttachments = this.parent.profileAttachments;

        // If no profileAttachments uploaded, profileImage is required
        if (!profileAttachments || !profileAttachments?.fileList?.length) {
          if (!value) {
            return this.createError({
              message: 'プロフィール画像をアップロードしてください。',
            });
          }
          return true;
        }

        return true;
      }),
    attachment: yup
      .mixed()
      .test('attachmentsValidation', '', function (value: any) {
        const coverImage = this.parent.coverImage;
        const attachments = value as {
          file: UploadFile;
          fileList: UploadFile[];
        };

        // Get the file from either fileList or the current file object
        const fileFromList = attachments?.fileList?.[0]?.originFileObj;
        const currentFile = attachments?.file?.originFileObj;
        const file = fileFromList || currentFile;

        // If coverImage exists and no file, validation passes
        if (coverImage && !file) {
          return true;
        }

        // If no file at all, require them
        if (!file) {
          return this.createError({
            message: ERROR_MESSAGE_FIELD.UPLOAD_MISSING_FILE('カバー画像'),
          });
        }

        // Validate file type first (before size check)
        if (!SUPPORTED_FORMATS.includes(file.type ?? '')) {
          return this.createError({
            message: '画像は .jpg、.png、.jpeg 形式ではありません。',
          });
        }

        // Validate file size
        if ((file?.size ?? 0) > FILE_SIZE_LIMIT) {
          return this.createError({
            message: '画像のサイズは10MBを超えています。',
          });
        }

        return true;
      }),
    profileAttachment: yup
      .mixed()
      .test('profileAttachmentsValidation', '', function (value: any) {
        const profileImage = this.parent.profileImage;
        const profileAttachments = value as {
          file: UploadFile;
          fileList: UploadFile[];
        };

        // Get the file from either fileList or the current file object
        const fileFromList = profileAttachments?.fileList?.[0]?.originFileObj;
        const currentFile = profileAttachments?.file?.originFileObj;
        const file = fileFromList || currentFile;

        // If profileImage exists and no file, validation passes
        if (profileImage && !file) {
          return true;
        }

        // If no file at all, require them
        if (!file) {
          return this.createError({
            message:
              ERROR_MESSAGE_FIELD.UPLOAD_MISSING_FILE('プロフィール画像'),
          });
        }

        // Validate file type first (before size check)
        if (!SUPPORTED_FORMATS.includes(file.type ?? '')) {
          return this.createError({
            message: '画像は .jpg、.png、.jpeg 形式ではありません。',
          });
        }

        // Validate file size
        if ((file?.size ?? 0) > FILE_SIZE_LIMIT) {
          return this.createError({
            message: '画像のサイズは10MBを超えています。',
          });
        }

        return true;
      }),
    url1: yup
      .string()
      .nullable()
      .test('url-or-empty', 'URLは正しい形式で入力してください。', (value) => {
        if (!value || value.trim() === '') {
          return true;
        }
        try {
          new URL(value);
          return true;
        } catch {
          return false;
        }
      })
      .max(2000, 'URLは2000文字以内で入力してください。'),
    url2: yup
      .string()
      .nullable()
      .test('url-or-empty', 'URLは正しい形式で入力してください。', (value) => {
        if (!value || value.trim() === '') {
          return true;
        }
        try {
          new URL(value);
          return true;
        } catch {
          return false;
        }
      })
      .max(2000, 'URLは2000文字以内で入力してください。'),
    url3: yup
      .string()
      .nullable()
      .test('url-or-empty', 'URLは正しい形式で入力してください。', (value) => {
        if (!value || value.trim() === '') {
          return true;
        }
        try {
          new URL(value);
          return true;
        } catch {
          return false;
        }
      })
      .max(2000, 'URLは2000文字以内で入力してください。'),
  } as any);
